export const COMMON_STATE_KEYS = Object.freeze({
  IS_PUSH_NOTIFICATION_SHOWN: 'isPushNotificationShown',
  IS_INJECTED_HP: 'isInjectedHP',
  IS_INJECTED_HP_IN_VIEW: 'isInjectedHPInView',
  VIDEO_CAROUSEL_STATUS: 'videoCarouselStatus',
  PLAYERS_ON_PAGE: 'playersOnPage',
});

export const initialState = {
  [COMMON_STATE_KEYS.IS_PUSH_NOTIFICATION_SHOWN]: undefined,
  [COMMON_STATE_KEYS.IS_INJECTED_HP]: false,
  [COMMON_STATE_KEYS.IS_INJECTED_HP_IN_VIEW]: false,
  [COMMON_STATE_KEYS.VIDEO_CAROUSEL_STATUS]: undefined,
  [COMMON_STATE_KEYS.PLAYERS_ON_PAGE]: [],
};
